import GoingSvgTree from './goingSvgTree';
/**
 * 纵向组织机构树
 */
class GoingSvgVerTree extends GoingSvgTree{
    constructor(d3, options, data) {
        super(d3, options, data,false);
        //对扩展属性进行处理
        this._initExtendsOptions();
        this.drawTree({width:this.options.width, d3, data},"ver");
    }

}

GoingSvgVerTree.prototype._initExtendsOptions = function () {
    //默认配置
    this.options["nodeWidth"]=[150,150,150];
    this.options["defWidth"]=150;
    this.options["nodeHeight"]=33;
    this.options["nodeLeftSpace"]=100;
    this.options["nodeTopSpace"]=170;
    //设置当前最大层级
    this.maxDepth=this.options.showLevel;
};



//对需要显示对节点 进行位置控制
GoingSvgVerTree.prototype._initShowNodePosition=function(node,nodeEnter,transition){
    // Transition nodes to their new position.
    node.merge(nodeEnter).transition(transition)
        .attr("transform", function (d) {
            return `translate(${d.x},${d.y})`;
        })
        .attr("fill-opacity", 1)
        .attr("stroke-opacity", 1);
};

GoingSvgVerTree.prototype.initSvgPosition=function(svg,treeObj,d3){
    //如果svg对高度大于容器高度 才需要这样移动
    svg.call(treeObj.zoom).transition().duration(10).call(
        treeObj.zoom.transform,
        d3.zoomIdentity.translate(parseFloat(treeObj.containerWidth)/2-parseFloat(treeObj.options.nodeWidth)/2, 100)
    );
    setTimeout(()=>{
        $('#' + this.containerId).css("visibility","visible");
    },15);
};

/**
 * 获取svg图的宽度
 */
GoingSvgVerTree.prototype.getSvgWidth=function(root){
    const margin = ({top: 10, right: 120, bottom: 10, left: 40});
    let left = root;
    let right = root;
    root.eachBefore(node => {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
    });
    this.moveHeight=-((left.x ) - margin.top);
    let svgWidth = (right.x + this.options.nodeHeight/2) - (left.x - this.options.nodeHeight/2) + margin.top + margin.bottom;
    this.svgWidth=svgWidth+200;
    return this.containerWidth;
};

/**
 * 获取svg图的宽度
 */
GoingSvgVerTree.prototype.setSvgWidth=function(){
    //如果svg的宽度大于容器宽度
    if(this.svgWidth>this.containerWidth){
        if(this.setSvgEye){
            this.scrollerWidth=this.svgWidth-this.containerWidth;
            this.setSvgEye(true);
        }
        this["svgEye"]=true;
        //需要修改容器的宽度
        $('#' + this.containerId).css("width",this.svgWidth);

        $("#"+this.options.eyeBodyId).html("");
        this.svg.clone(true).attr("id","svgTempId");
        $("#svgTempId").appendTo($("#"+this.options.eyeBodyId));
    }

};

GoingSvgVerTree.prototype.getSvgHeight=function(root){

    return this.containerHeight;
};




function getZheLinePoint(source,target){
    return (target.y-source.y-source.nodeHeight)/2;
}
/**
 * 这里需要分节点类型来进行区分绘制 目的在于减少重复线条对绘制。
 * @param d
 * @returns {string}
 */
GoingSvgVerTree.prototype.diagonal=function(d){
    var path=null;
    let nodeW=d.source.nodeWidth/2,nodeY=d.source.nodeHeight/2;
    //如果是第一个节点
    if(d.target.first===true){
        if(isNaN(d.source.x + nodeW)){
            return void(0);
        }
        path = "M" + (d.source.x + nodeW) + " " + d.source.y +
            "L" + (d.source.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) +
            " L" + (d.target.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) + " L" +
            (d.target.x + nodeW) + " " + (d.target.y  +nodeY);
        return path;
    }
    // //如果是最后对节点
    if(d.target.last===true){
        if(isNaN(d.source.x + nodeW)){
            return void(0);
        }
        path = "M" + (d.source.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) +
            "L" + (d.source.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) +
            " L" + (d.target.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) + " L" +
            (d.target.x + nodeW) + " " + (d.target.y  +nodeY);
        return path;
    }
    if(isNaN(d.source.x + nodeW)){
        return void(0);
    }
    //如果是中间节点
    path = "M" + (d.target.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) +
        "L" + (d.target.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) +
        " L" + (d.target.x + nodeW) + " " + (d.target.y - getZheLinePoint(d.source,d.target)) + " L" +
        (d.target.x + nodeW) + " " + (d.target.y  +nodeY);
    return path;
};


/**
 * 绘制圆圈圈
 * @param nodeEnter
 * @private
 */
GoingSvgVerTree.prototype._appendCircle=function(nodeEnter){
    let treeObj=this;
    nodeEnter.append("circle")
        .attr("r", this.options.circleWidth)
        .attr("fill", "#fff")
        .attr("stroke", treeObj.options["nodeOverColor"])
        .attr("transform", (d) => {
            return `translate(${parseFloat(this.options.nodeWidth)/2},${parseFloat(this.options.nodeHeight)})`;
        })
        .attr("id", (d) => {
            return "cir_"+ d.id;
        })
        .attr("fill-opacity", (d)=>{
            return d.depth>0?1:0;
        })
        .attr("stroke-opacity", (d)=>{
            return d.depth>0?1:0;
        })
        .attr("stroke-width", (d)=>{
            return d.depth>0?1:0;
        })
};

/**
 * 添加展开 收缩图标
 * @param nodeEnter
 * @param d3
 * @private
 */
GoingSvgVerTree.prototype._appendExpandImg=function(nodeEnter,d3){
    let treeObj=this;
    nodeEnter.append("image")
        .attr("xlink:href",(d)=>{
            if(d.depth>=treeObj.options["showLevel"]&&d.hasChildren){
                return window.SysConfigUtils.go_eplat_adress+"/static/svg/plus.svg";
            }else{
                if(d.children){
                    return window.SysConfigUtils.go_eplat_adress+"/static/svg/line.svg";
                }else{
                    d3.select("#cir_"+d.id).attr("opacity", 0);
                    d3.select("#icon_"+d.id).attr("opacity", 0);
                }
            }
        })
        .attr("width", 12)
        .attr("id", (d) => {
            return "icon_"+d.id;
        })
        .attr("x", () => {
            return parseFloat(this.options.nodeWidth)/2-6;
        })
        .attr("y", () => {
            return parseFloat(this.options.nodeHeight)/2+10;
        })
        .attr("opacity", (d)=>{
            return d.depth>0?1:0;
        })
        .attr("height", 12);
};

/**
 * 添加字 text
 * @param nodeEnter
 * @private
 */
GoingSvgVerTree.prototype._appendText=function(nodeEnter){
    nodeEnter.append("text")
        .attr("y", parseFloat(this.options.nodeHeight)/2+2)
        .attr("class", "treeText")
        .attr("x", (d)=>{
            $(`<span id="labelTemp">${d.data.name}</span>`).appendTo($('#' + this.containerId));
            let labelWid=$("#labelTemp").width();$("#labelTemp").remove();
            return parseFloat(this.options.nodeWidth)/2-labelWid/2;
        })
        .text(d => d.data.name)
        // .clone(true).lower()
        .attr("stroke-linejoin", "round")
        .attr("stroke-width", "1px")
        .style('stroke',"#FFF")
        .attr("stroke", "#fff");
};


export default GoingSvgVerTree;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingSvgVerTree.js